import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const navItems = [
  { to: '/', labelKey: 'navigation.nav_home' },
  { to: '/services', labelKey: 'navigation.nav_services' },
  { to: '/illustrations', labelKey: 'navigation.nav_supported_products' },
  { to: '/news', labelKey: 'navigation.nav_news' },
  { to: '/about', labelKey: 'navigation.nav_about_us' },
  { to: '/careers', labelKey: 'navigation.nav_careers' },
];

const NavItems = ({ onItemClick }) => {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  return (
    <ul className='flex flex-col lg:flex-row gap-8'>
      {navItems.map(({ to, labelKey }) => (
        <li key={to}>
          <Link
            to={to}
            className={`block text-base font-medium ${
              (pathname === '/' && to === '/') ||
              (to !== '/' && pathname.startsWith(to))
                ? 'text-primary-red'
                : ''
            }`}
            onClick={() => {
              if (onItemClick) {
                onItemClick();
              }
            }}
          >
            {t(labelKey)}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default NavItems;